import React from "react";
import "./GetMusicOnAWA.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnAWA = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload music & artwork",
    "Select AWA distribution",
    "Release music worldwide",
    "Reach Japanese listeners",
    "Track streams & royalties"
  ];

  return (
    <>
      <Helmet>
        <title>
          Get Your Music on AWA Music | AWA Distribution | FT Tunes
        </title>

        <meta
          name="description"
          content="Distribute your music on AWA Music with FT Tunes. Reach millions of listeners in Japan and worldwide with fast music distribution and global royalty collection."
        />

        <meta
          name="keywords"
          content="AWA music distribution, upload music to AWA Japan, AWA for artists, music distribution Japan, FT Tunes distribution"
        />

        <meta name="robots" content="index, follow" />

        <meta property="og:title" content="Get Your Music on AWA Music | FT Tunes" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.fttunes.com/get-your-music-on-awa" />
      </Helmet>

      <div className="awa-page">

        {/* HERO */}
        <section className="awa-hero">
          <Container>

            <img
              src="/Images/awa-logo.png"
              alt="AWA Music Distribution"
              className="awa-logo"
            />

            <h1>Get Your Music on AWA</h1>

            <p>
              Distribute your music on AWA and reach millions of listeners
              across Japan and global streaming audiences. Upload your
              singles, albums, and EPs with FT Tunes and grow your music
              career through one of Japan’s fastest-growing music streaming
              platforms.
            </p>

            <Button
              className="gradient-btn"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-awa"></div>
        </section>


        {/* SHOWCASE */}
        <section className="awa-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach The Japanese Music Market</h2>

                <p>
                  AWA connects artists with millions of active music listeners
                  in Japan. Expand your global fanbase and make your music
                  discoverable across mobile apps, playlists, and streaming
                  platforms.
                </p>

                <Button
                  className="outline-btn"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Distribute Now
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-music-on-awa.png"
                  alt="AWA music platform"
                  className="awa-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="awa-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="awa-benefits">
          <Container>

            <h2 className="section-title">
              Built For Independent Artists
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Japan Market Access</h5>
                  <p>Reach millions of Japanese music fans instantly.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Playlist Discovery</h5>
                  <p>Get featured in curated AWA playlists.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Streaming Revenue</h5>
                  <p>Earn royalties from every stream worldwide.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card">
                  <h5>Full Ownership</h5>
                  <p>You keep 100% rights to your music.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="awa-cta">
          <Container>

            <h2>Start Growing on AWA Today</h2>

            <Button
              className="gradient-btn big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Upload Your Music
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnAWA;